module.exports = __webpack_public_path__ + "d87ea4f29b0b0073812c0b000f1c9f7c.png";